export default "__VITE_ASSET__a99375e6__"